import client from '../../../apis/portaliref';
import helper from 'helpers/steinerHelper';

const paramsMap = {
    per_page: 'perPage',
    page: 'page',
    sort_field: 'orderKey',
    sort_direction: 'orderDirection',
    stato_online: 'stato_online',
    tipologia_popolamento: 'tipologia_popolamento',
    sorgente: 'sorgente',
    ricerca: 'q'
};

const apis = helper.createApi('landing', client, paramsMap);

apis.attivaLanding = (landingId, value) => {
    return client({
        url: `landing/${landingId}/online`,
        method: 'post',
        data: { stato_online: value },
    });
};

apis.aggiornaLanding = (landingId, data) => {
    return client({
        url: `landing/${landingId}`,
        method: 'patch',
        data: data
    });
};

apis.cercaLandingId = (landingId) => {
    return client({
        url: `landing/${landingId}`,
        method: 'get'
    })
}

apis.aggiornaPortaliLanding = (landingId, data) => {
    return client({
        url: `landing/portali/${landingId}`,
        method: 'patch',
        data: data
    });
};

apis.aggiornaConfigurazioneManualeLanding = (landingId, data) => {
    return client({
        url: `landing/configurazioneManuale/${landingId}`,
        method: 'patch',
        data: data
    });
};

apis.aggiornaConfigurazioneAutomaticaLanding = (landingId, data) => {
    return client({
        url: `landing/configurazioneAutomatica/${landingId}`,
        method: 'patch',
        data: data
    });
};

apis.addAnagraficaToLanding = (landingId, data) => {
    return client({
        url: `landing/${landingId}/anagrafica`,
        method: 'post',
        data: data
    });
};

apis.removeAnagraficaFromLanding = (landingId, data) => {
    return client({
        url: `landing/${landingId}/anagrafica`,
        method: 'delete',
        data: data
    });
};

apis.addOffertaToLanding = (landingId, data) => {
    return client({
        url: `landing/${landingId}/offerta`,
        method: 'post',
        data: data
    });
};

apis.removeOffertaFromLanding = (landingId, data) => {
    return client({
        url: `landing/${landingId}/offerta`,
        method: 'delete',
        data: data
    });
};

apis.creaLanding = (data) => {
    return client({
        url: 'landing',
        method: 'post',
        data: data
    });
};

apis.listaPerLandingManuale = (tipologia, data) => {
    const portaliDaAggiornare = [];
    data.portali.forEach((portale) => {
        portaliDaAggiornare.push(
            typeof portale !== 'object' ? portale : portale.value
        );
    });
    let url = `${tipologia}/landing/${portaliDaAggiornare.join()}?per_page=${data.per_page}&page=${data.page}`;
    if (data.comune) {
        url = url.concat(`&comune=${data.comune}`);
    }
    if (data.regione) {
        url = url.concat(`&regione=${data.regione}`);
    }
    if (data.categoria_struttura) {
        url = url.concat(`&categoria_struttura=${data.categoria_struttura}`);
    }
    if (data.ao_hotel_ids.length > 0) {
        url = url.concat(`&ao_hotel_ids=${data.ao_hotel_ids.join()}`);
    }
    if (data.senza_ao_hotel_ids.length > 0) {
        url = url.concat(`&senza_ao_hotel_ids=${data.senza_ao_hotel_ids.join()}`);
    }
    if (data.contratto_attivo) {
        url = url.concat(`&contratto_attivo=${data.contratto_attivo}`);
    }
    if (data.ricerca) {
        url = url.concat(`&ricerca=${data.ricerca}`);
    }
    if (data.sort_field) {
        url = url.concat(`&sort_field=${data.sort_field}&sort_direction=${data.sort_direction}`);
    }
    return client({
        url: url,
        method: 'get',
        data: data
    });
}

apis.elencoDestinazioni = () => {
    return client({
        url: 'destinazioni/listaNomi',
        method: 'GET',
    });
};

apis.elencoComuniId = () => {
    return client({
        url: 'destinazioni/listaIdComuni',
        method: 'GET',
    });
};

apis.elencoServiziId = () => {
    return client({
        url: 'servizi/listaIdServizi',
        method: 'GET',
    });
};

apis.elencoHotelDisponibiliPerPortali = (portali) => {
    return client({
        url: 'anagrafica/listaIdPerPortali',
        method: 'POST',
        data: {
            portali: portali
        }
    });
};

apis.associatiLandingManuale = (landingId) => {
    return client({
        url: `landing/${landingId}/associati-backoffice`,
        method: 'GET'
    });
}

apis.informazioniLandingAutomatiche = (data) => {
    return client({
        url: `landing/informazioniAggiuntive`,
        method: 'POST',
        data: data
    });
}

apis.svuotaLanding = (landingId) => {
    return client({
        url: `landing/${landingId}/svuota`,
        method: 'patch',
    });
};

export default apis;